import { ChatSessionDTO } from "@tumtutor/shared/dto";
import { Dispatch, SetStateAction } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ChatSessionCard } from "./ChatSessionCard";

interface ChatSessionOverviewProps {
  chatSessions: ChatSessionDTO[];
  setSearchParams: (
    params: { sessionId: string },
    options?: { replace?: boolean },
  ) => void;
  currentChatSession?: ChatSessionDTO;
  setChatSessionToDelete: Dispatch<SetStateAction<string>>;
  patchChatSession: ({ sessionId, courseId, body: { name } }) => void;
  deleteChatSessionModalId: string;
}

export function ChatSessionOverview({
  chatSessions,
  setSearchParams,
  currentChatSession,
  setChatSessionToDelete,
  patchChatSession,
  deleteChatSessionModalId,
}: ChatSessionOverviewProps) {
  const chatSessionCardProps = {
    setSearchParams,
    currentChatSession,
    setChatSessionToDelete,
    patchChatSession,
    deleteChatSessionModalId,
  };

  const { t } = useTranslation(["chatPage"]);

  const getDateOffset = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const yesterday = getDateOffset(1);
  const dayBeforeYesterday = getDateOffset(2);
  const sevenDaysAgo = getDateOffset(7);
  const thirtyDaysAgo = getDateOffset(30);

  const todaySessions = chatSessions.filter(
    (session) =>
      new Date(session.created).toDateString() === new Date().toDateString(),
  );

  const yesterdaySessions = chatSessions.filter(
    (session) =>
      new Date(session.created).toDateString() === yesterday.toDateString(),
  );

  const last7DaysSessions = chatSessions.filter(
    (session) =>
      new Date(session.created) > sevenDaysAgo &&
      new Date(session.created) <= dayBeforeYesterday,
  );

  const last30DaysSessions = chatSessions.filter(
    (session) =>
      new Date(session.created) > thirtyDaysAgo &&
      new Date(session.created) <= sevenDaysAgo,
  );

  return (
    <>
      {[
        {
          sessions: todaySessions,
          title: t("chatSession.todayHeader"),
        },
        {
          sessions: yesterdaySessions,
          title: t("chatSession.yesterdayHeader"),
        },
        {
          sessions: last7DaysSessions,
          title: t("chatSession.last7DaysHeader"),
        },
        {
          sessions: last30DaysSessions,
          title: t("chatSession.last30DaysHeader"),
        },
      ].map(
        ({ sessions, title }) =>
          sessions.length > 0 && (
            <React.Fragment key={title}>
              <li
                className="menu-title text-base-content text-lg"
                key={`${title}-header`}
              >
                {title}
              </li>
              {sessions.map((session) => (
                <ChatSessionCard
                  key={session.id}
                  session={session}
                  {...chatSessionCardProps}
                />
              ))}
            </React.Fragment>
          ),
      )}
    </>
  );
}
